import React, { useState } from 'react';

const PHONE = '905330318858';

const Contact = () => {
    const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const text =
            `Merhaba, ben ${form.name}.%0A` +
            `E-posta: ${form.email}%0A` +
            `Telefon: ${form.phone}%0A%0A` +
            `${form.message}`;
        window.open(`https://wa.me/${PHONE}?text=${text}`, '_blank');
    };

    return (
        <section className="contact" id="iletisim">
            <div className="contact__container">
                <div className="contact__info">
                    <p className="section-eyebrow">İletişim</p>
                    <h2 className="section-title">BİZE ULAŞIN</h2>
                    <div className="contact__details">
                        <div className="contact__item">
                            <div className="contact__icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </div>
                            <div>
                                <span className="contact__label">Adres</span>
                                <p className="contact__value">
                                    Fatih Sultan Mehmet Mah. Reçine Sk.<br />No: 42, Sarıyer / İSTANBUL
                                </p>
                            </div>
                        </div>

                        <div className="contact__item">
                            <div className="contact__icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                            </div>
                            <div>
                                <span className="contact__label">Telefon</span>
                                <p className="contact__value">+90 533 031 88 58</p>
                            </div>
                        </div>

                        <div className="contact__item">
                            <div className="contact__icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <div>
                                <span className="contact__label">E-posta</span>
                                <p className="contact__value">pelinkecili@arthyapi.com</p>
                            </div>
                        </div>
                    </div>
                </div>

                <form className="contact__form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Ad Soyad</label>
                        <input
                            type="text" id="name" name="name"
                            placeholder="Ad Soyadınız" required
                            value={form.name} onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">E-posta</label>
                        <input
                            type="email" id="email" name="email"
                            placeholder="E-posta Adresiniz" required
                            value={form.email} onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Telefon</label>
                        <input
                            type="tel" id="phone" name="phone"
                            placeholder="Telefon Numaranız"
                            value={form.phone} onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Mesaj</label>
                        <textarea
                            id="message" name="message" rows="5"
                            placeholder="Mesajınızı buraya yazın..." required
                            value={form.message} onChange={handleChange}
                        />
                    </div>
                    <button type="submit" className="btn btn--primary btn--full">
                        WHATSAPP'A GÖNDER
                    </button>
                </form>
            </div>
        </section>
    );
};

export default Contact;
